"use strict";
import extensions from "video-extensions";
export const isVideo = (path) => extensions.find((ext) => path?.endsWith(`.${ext}`)) !== void 0;
